var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36996 0.295384C7.75911 0.68728 7.75688 1.32044 7.36499 1.70959L2.41921 6.6207L7.36499 11.5318C7.75688 11.921 7.75911 12.5541 7.36996 12.946C6.98081 13.3379 6.34765 13.3401 5.95575 12.951L0.295384 7.33029C0.106325 7.14255 0 6.88713 0 6.6207C0 6.35426 0.106325 6.09884 0.295384 5.91111L5.95575 0.290411C6.34765 -0.0987375 6.98081 -0.0965109 7.36996 0.295384Z",
    fill: "#323A45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prevIcon.738e44babf5c7a19247c734a06a739a5.svg";
export { ForwardRef as ReactComponent };